import React from 'react';
import { ASSETS } from '@/shared/constants/assets';
import './styles.css';

// As ilustrações vêm do bucket externo: se falharem, some só a imagem (sem ícone quebrado
// nem o texto do alt), mantendo o espaço para não desalinhar o texto ao lado.
const esconderImagem = (event) => {
    event.currentTarget.style.visibility = 'hidden';
};

function Tips() {
    return (
        <section className="tips-container">
            <div className="img-text">
                <div className="icon-container">
                    <img id="celular-img" src={ASSETS.dicaCelularChat} alt="celular" onError={esconderImagem}></img>
                </div>
                <li>
                    Compartilhe seu link de convite com seus amigos motoristas.<br/>
                    Categoria da CNH C, D ou E.
                </li>
            </div>
            <div className="img-text">
                <div className="icon-container">
                    <img id="nuvem-img" src={ASSETS.dicaNuvemDownload} alt="nuvem-download" onError={esconderImagem}></img>
                </div>
                <li>
                    Seus amigos devem baixar o app <br /> Rede Frota Conta Digital com seu link de convite.
                </li>
            </div>
            <div className="img-text">
                <div className="icon-container">
                    <img id="cartao-img" src={ASSETS.dicaCartaoDinheiro} alt="cartao" onError={esconderImagem}></img>
                </div>
                <li>
                    Você contribui com a nossa missão de levar liberdade financeira para quem está na estrada.
                </li>
            </div>
              <div className="img-texts">
              <br>
              </br>
                <li>
                   Versão {process.env.REACT_APP_BUILD_NUMBER}
                </li> 
            </div>
            
        </section>
    );
}

export default Tips;